const COLORS = {
  PRIMARY: "primary",
  GHOST: "ghost",
  PINK: 'pink',
};

const SIZES = {
  XS: "xs",
  S: "s",
  M: "m",
  XL: "xl",
  ASM: "asm",
};

export { COLORS, SIZES };
